export default "__VITE_ASSET__U6wbo8fN__"